import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import moment from 'moment';
import {BUSCAR_DADOS_VEXADO_BI} from '../types';

export default function buscarDadosVexadoBI(idEmpresa, dataInicio, dataFim, empresas, grupos, isAgencia, empresasSemGrupo) {
    let url = `${URL}/vexado-bi?idEmpresa=${idEmpresa}`;
    if (empresas) {
        url = `${url}&empresas=${empresas}`
    }

    if (isAgencia) {
        url = `${url}&agencia=${isAgencia}`
    }

    if (grupos) {
        url = `${url}&grupos=${grupos}`
    }

    url = `${url}&dataInicio=${moment(dataInicio)
        .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
        .format('YYYY-MM-DD')}&empresasSemGrupo=${empresasSemGrupo}`
    
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_DADOS_VEXADO_BI,
            payload: response.data

        })
    );
}
